import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import ru from './locales/ru.json';
import en from './locales/en.json';

const resources = {
  ru: {
    translation: ru
  },
  en: {
    translation: en
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    
    detection: {
      // Order of detection methods
      order: ['localStorage', 'navigator', 'htmlTag'],
      
      // Keys to save/retrieve language from localStorage
      caches: ['localStorage'],
      
      // Language detection options
      lookupLocalStorage: 'ivp_gallery_language',
    },

    interpolation: {
      escapeValue: false, // React already does escaping
    },

    // Namespace settings
    defaultNS: 'translation',
    
    // Return key if translation is missing
    saveMissing: true,
    
    // React options
    react: {
      useSuspense: false,
    }
  });

export default i18n;